import { render, staticRenderFns } from "./PreviousButton.vue?vue&type=template&id=0344a68d&scoped=true"
import script from "./PreviousButton.vue?vue&type=script&lang=js"
export * from "./PreviousButton.vue?vue&type=script&lang=js"
import style0 from "./PreviousButton.vue?vue&type=style&index=0&id=0344a68d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344a68d",
  null
  
)

export default component.exports